module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/163-papua-new-guinea-cbe05283feb527f5e00607dd3364b1d7.svg";